import ProviderIntegrator from "./ProviderIntegrator";

export default ProviderIntegrator;
